import PermissionButton from "../../components/ui/PermissionButton";
import { useState, useEffect } from "react";

export default function VendorQuotations({ poId }) {
  const [quotations, setQuotations] = useState([]);

  useEffect(() => {
    if (!poId) return;

    fetch(`/api/admin/quotations/${poId}`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setQuotations(data.data);
        }
      });
  }, [poId]);

const vendorQuotes = quotations;

  if (vendorQuotes.length === 0) {
    return <p className="text-gray-400">No quotations found.</p>;
  }

  return (
    <div className="space-y-4">
      {vendorQuotes.map((q) => {
        const total = q.price + (q.price * q.gst) / 100;

        return (
          <div
            key={q.id}
            className="rounded-xl bg-black/40 border border-white/10 p-4 flex justify-between items-center"
          >
            <div>
              <p className="font-medium">{q.item}</p>
              <p className="text-xs text-gray-400">
                ₹{q.price} + {q.gst}% GST • {q.deliveryDays} days
              </p>
            </div>

            <div className="flex items-center gap-4">
              <span
                className={`px-3 py-1 rounded-full text-xs ${
                  q.status === "Finalized"
                    ? "bg-emerald-500/20 text-emerald-400"
                    : "bg-amber-400/20 text-amber-400"
                }`}
              >
                {q.status}
              </span>

              {q.status === "Pending" && (
                <PermissionButton permissionModule="purchase_orders"
                  className="px-4 py-2 rounded-lg bg-amber-400 text-black text-xs font-medium"
                >
                  Finalize
                </PermissionButton>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
